// Generated by Melange

import * as Buhta_landing__KassaEpilogue from "./KassaEpilogue.js";
import * as Buhta_landing__KassaIntro from "./KassaIntro.js";
import * as Buhta_landing__KassaMiddle from "./KassaMiddle.js";
import * as Buhta_landing__KassaOutro from "./KassaOutro.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Kassa(Props) {
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_landing__KassaIntro.make, {}),
      JsxRuntime.jsx(Buhta_landing__KassaMiddle.make, {}),
      JsxRuntime.jsx(Buhta_landing__KassaOutro.make, {}),
      JsxRuntime.jsx(Buhta_landing__KassaEpilogue.make, {})
    ]
  });
}

const make = Kassa;

export {
  make,
}
/* Buhta_landing__KassaEpilogue Not a pure module */
